import { createSelector } from '@reduxjs/toolkit';
import { EElectronicTradingType } from '../../../../packages/JsonQuery/types/electronicTradingType';
import { selectElectronicTrading } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Не показывать', value: EElectronicTradingType.DoNotDisplay },
  { label: 'Только торги и залоговая недвижимость', value: EElectronicTradingType.ElectronicTradingOnly },
];

export const selectElectronicTradingFilter = createSelector(selectElectronicTrading, value => ({
  label: 'Торги и залоговая недвижимость',
  value: [value],
  options: OPTIONS,
}));
